import { EARTH_RADIUS } from "../../../constants/geodesyConstants";

/** Haversine 距離(m) */
export function haversineMeters(lat1, lng1, lat2, lng2) {
  const toRad = (d) => (d * Math.PI) / 180;
  const dLat = toRad(lat2 - lat1);
  const dLng = toRad(lng2 - lng1);
  const a =
    Math.sin(dLat / 2) ** 2 +
    Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLng / 2) ** 2;
  return 2 * EARTH_RADIUS * Math.asin(Math.sqrt(a));
}

export function pickNearestCampus(lat, lng, campusDataJson) {
  const list = campusDataJson?.campusList ?? [];
  if (!list.length) return 1;

  let bestIdx = 0,
    bestDist = Infinity;
  list.forEach((c, i) => {
    const clat = c.map.center?.lat;
    const clng = c.map.center?.lng;
    if (typeof clat !== "number" || typeof clng !== "number") return;
    const d = haversineMeters(lat, lng, clat, clng);
    if (d < bestDist) {
      bestDist = d;
      bestIdx = i;
    }
  });

  return bestDist < Infinity ? bestIdx + 1 : 1;
}
